import React, { useEffect, useState } from "react";

// Jds
import {
  Container,
  Divider,
  Heading,
  Icon,
  InputField,
  Modal,
  Text,
  Tooltip,
} from "@jds/core";

// Local
import CloseButton from "./Buttons/CloseButton";
import { Box } from "@mui/material";
import { validateTextInput } from "../../util/validation";
import useInput from "../../hooks/use-input";

export default function JdsModal(props) {
  const { headerProps, kind } = props;
  const headerDivider = headerProps?.divider || "true";
  const modalKind = kind || "custom";

  const [close, setClose] = useState(true);

  const [headerEdit, setHeaderEdit] = useState(false);
  const [enteredHeader, setEnteredHeader] = useState("");

  const {
    value: name,
    isValid: nameIsValid,
    hasError: nameHasError,
    valueChangeHandler: nameChangeHandler,
    inputBlurHandler: nameBlurHandler,
    reset: resetnameInput,
  } = useInput(validateTextInput, {
    type: "text",
    value: headerProps?.inputValue || "",
  });

  const handleClose = () => {
    setClose(true);
    props?.onClose?.();
  };

  useEffect(() => {
    if (props.openModal) {
      setClose(false);
    }

    setTimeout(() => {
      const container = document.querySelector("#custom-container");
      const child = document.querySelector(
        `#custom-container .${props?.contentContainerProps?.className}`,
      );

      if (container && child) {
        const widthClass = child.className
          .split(" ")
          .find((cls) => /^w\d+$/.test(cls));

        if (widthClass) {
          const widthValue = widthClass.replace("w", "");
          container.style.width = "100%";
          container.style.maxWidth = `${widthValue}px`;
        }
      }
    }, 50);
  }, [props.openModal]);

  useEffect(() => {
    if (props.apiSuccess) {
      setClose(true);
    }
  }, [props?.apiSuccess]);

  const triggerProps = {
    onClick: () => setClose(false),
    ...props?.trigger?.props,
  };

  const TriggerComponent = props?.clone
    ? React.cloneElement(props?.trigger?.component, triggerProps)
    : props?.trigger?.component;

  const modalContent = React.cloneElement(props.children || <></>, {
    closeModal: props.onClose || handleClose,
    isParentModal: true,
    close: props.close || close,
  });

  return (
    <>
      {TriggerComponent && (
        <Box sx={{ textWrap: "nowrap" }}>
          {props?.clone
            ? TriggerComponent
            : props?.trigger?.component && (
                <TriggerComponent {...triggerProps} />
              )}
        </Box>
      )}
      <Modal
        header=""
        size="s"
        kind="custom"
        onClose={handleClose}
        close={close}
        {...props}
        primaryCTA={
          props.primaryCTA
            ? {
                ...props.primaryCTA,
                onClick: (e) => {
                  props.onPrimaryClick?.(e);
                },
              }
            : undefined
        }
        secondaryCTA={
          props.secondaryCTA
            ? {
                ...props.secondaryCTA,
                onClick: (e) => {
                  console.log("[Analytics] Modal CTA Clicked →", {
                    action: "Secondary CTA",
                    modalHeader: props.header,
                    buttonText: props.secondaryCTA?.title,
                  });
                  props.onSecondaryClick?.(e);
                },
              }
            : undefined
        }>
        <div style={{ width: "100%" }}>
          {modalKind == "custom" && (
            <Container
              fullWidth
              horizontalAlign="space-between"
              verticalAlign="center"
              style={
                {
                  // marginBottom: headerDivider !== "true" ? "40px" : "",
                }
              }>
              {/* <Tooltip label={props?.header} position="bottom"> */}
              {
                <Container verticalAlign="center" gap={8}>
                  <Heading
                    appearance={headerProps?.appearance || "body-l-bold"}
                    text={props?.header || ""}
                    maxLines={1}
                  />
                  {/* {headerProps?.isEditable && (
                    <Icon
                      ic="IcEditPen"
                      onClick={() => {
                        setHeaderEdit(true);
                        headerProps?.onEdit && headerProps?.onEdit();
                      }}
                    />
                  )} */}
                </Container>
              }
              {/* </Tooltip> */}
              {/* {headerEdit && (
                <Container verticalAlign="end" style={{ width: "50%" }}>
                  <InputField value={name} onChange={nameChangeHandler} />
                  <Icon
                    ic="IcRemove"
                    color="error"
                    onClick={() => setHeaderEdit(false)}
                  />
                  <Icon
                    ic="IcSuccess"
                    color="primary"
                    onClick={() => {
                      setHeaderEdit(false);
                      headerProps?.onConfirm(name);
                      resetnameInput();
                    }}
                  />
                </Container>
              )} */}

              <CloseButton onClick={handleClose} />
            </Container>
          )}
          {modalKind == "custom" && headerDivider == "true" && (
            <Container
              style={{
                width: "calc(100% + 64px)",
                marginLeft: "-32px",
              }}>
              <Divider padPosition="vertical" pad="medium" />
            </Container>
          )}
          <div
            style={{
              overflow: "auto",
              maxHeight: "calc(100vh - 200px)",
              paddingRight: "10px",
            }}
            className={`custom-scrollbar ${props?.contentContainerProps?.className}`}>
            {modalContent}
          </div>
        </div>
      </Modal>
    </>
  );
}
